<template>
  <div class="modal fade" id="AddClientModal" tabindex="-1" client="dialog" ref="addAddClientModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" client="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Ajout de client</h4>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h5>Vous êtes sur le point de compléter de (s) client (s) à: {{ user }} </h5>
          <Form ref="passForm" @submit="addClient" :validation-schema="passSchema">
            <div class="row">
              <div class="col-md-12 mb-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Client <span class="text-danger">*</span>
                  </label>
                  <Multiselect
                    v-model="clients"
                    :options="clientOptions"
                    :close-on-select="false"
                    :preserve-search="true"
                    :clear-on-select="false"
                    :multiple="true"
                    :searchable="true"
                    mode="tags"
                    
                    placeholder="Sélectionner le client"
                    label="label"
                    track-by="label"
                  />
                  <span class="text-danger" v-if="showMErr">Le client est obligatoire</span>
                </div>
              </div>
              <button ref="submitButton" class="btn btn-primary" type="submit">
                Envoyer
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, watch } from 'vue';
import { Form } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, hideModal, success } from '@/utils/utils';
import { useRoute } from 'vue-router';
import { User } from '@/models/User';
import Multiselect from '@vueform/multiselect';

export default {
  name: "AddClientModal",
  components: {
    Form,
    Multiselect,
  },
  props: {
    item: {
      type: Number,
      default: 0,
    },
    // selectedUserId: {
    //   type: Number,
    //   default: 0,
    // },
    selectedUser: Object as () => User | undefined,
  },
  setup(props: any, { emit }: { emit: Function }) {
    const passSchema = Yup.object().shape({
      // La validation Yup peut être omise ici car nous gérons manuellement
    });

    const passForm = ref<any>(null);
    const addAddClientModalRef = ref<HTMLElement | null>(null);
    const route = useRoute();
    const clientOptions = ref<{ value: number; label: string }[]>([]);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const clients = ref<{ value: number; label: string }[]>([]); // Typage explicite pour un tableau
    const user = ref('');
    
    const showMErr = ref(false);

    const addClient = async (values: any, { resetForm }: { resetForm: () => void }) => {
      console.log("data send", clients.value);
      
      if (!props.selectedUser?.id) {
        error("User non sélectionné");
        return;
      }

     
      // Vérifiez les clients sélectionnés

      //const selectedClients = Array.isArray(clients.value) ? clients.value.map(client => client.value) : [];
      const selectedClients = clients.value ? clients.value.map(client => client.value) : [];
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value.disabled = true;
      }

      values['userId'] = props.selectedUser.id;
      values['clients'] = clients.value;

      console.log("Clients sélectionnés avant soumission:", clients.value);

      console.log("je mange", selectedClients)
      // Validation : vérifier si au moins un client est sélectionné
      if (selectedClients.length === 0) {
        showMErr.value = true;
        return;
      }
      showMErr.value = false;

      try {
        const { data } = await ApiService.post(`/clients/users/${props.selectedUser.id}`, values);
        
        console.log("je mange", values)
        if (data.code === 200) {
          success(data.message);
          resetForm();
          clients.value = []; // Réinitialiser les sélections après succès
          hideModal(addAddClientModalRef.value);
          emit('close');
        }
      } catch ({ response }) {
        submitButton.value!.disabled = false;
        error(response?.data?.message || 'Erreur lors de l\'ajout des clients');
      }
    };

    const fetchClients = async (userId: number) => {
      try {
        const response = await ApiService.get(`/resteante/clients/${userId}`);
        console.log("Clients récupérés:", response.data.data);
        const clientsData = response.data.data;
        clientOptions.value = clientsData.map((client: any) => ({
          value: client.id,
          label: client.nomClient && client.prenomClient
            ? `${client.nomClient} ${client.prenomClient}`
            : `${client.raisonSociale}`,
        }));
        console.log("Clients récupérésdddddddddddd:", clientOptions.value); // DEBUG
      } catch (err) {
        error('Erreur lors de la récupération des clients');
        console.error(err);
      }
    };

    watch(() => props.selectedUser, (newValue) => {
      // console.log("Prdouit sélectionné:", newValue.nom);
      user.value = newValue.nom;
      if (newValue && newValue.id != 0) {
        fetchClients(newValue.id);
      }
    });

watch(clients, (newValue) => {
  console.log("Valeur de clients mise à jour:", newValue);
});


    onMounted(() => {
      if (route.params.id) {
        fetchClients(parseInt(route.params.id as string));
      }
    });

    return {
      passSchema,
      addClient,
      submitButton,
      passForm,
      addAddClientModalRef,
      clientOptions,
      clients,
      showMErr,
      user
    };
  },
};
</script>